<script setup lang="ts">
import { useElementalForm } from '../ElementalFormContextProvider/context'
import FormSavingIndicator from '../FormSavingIndicator/index.vue'
import { useAutosave } from '../FormAutomaticSave/context'
import FormDebugger from '../ElementalFormContextProvider/debugger.vue'
import Button from '../../ui/button/Button.vue'
import FormErrorAlert from './FormErrorAlert.vue'
import FieldTitle from '@/components/ElementalForm/ElementalFormFields/FieldTitle/index.vue'
import OptionsButton from '@/components/ElementalForm/ElementalFormFields/OptionsButton/index.vue'
import TagMenu from '@/components/TagMenu/index.vue'
import IconButton from '@/components/IconButton/index.vue'
import IconAddWidget from '@/components/Icon/AddWidget/index.vue'
import { ElementalTypeEnum } from '~~/src/types/elemental'

defineOptions({
  name: 'FormHeader',
})

const { elementalType, isSidebarView, elemental } = useElementalForm()
const { injected } = useAutosave()

const handlerBack = () => {
  history.back()
}

const handlerScrollToAdvanced = () => {
  useDispatchCustomEvent('scroll-to', { id: 'advanced' })
}
const debugMode = import.meta.env.DEV
</script>

<template>
  <header
    v-if="!isSidebarView"
    :class="{
      'p-2': !isSidebarView,
      'p-1': isSidebarView,
      'border-b-1 border-softGray': !isSidebarView,
    }"
    class="flex w-full items-center  gap-2 sticky top-0 bg-white z-9999"
  >
    <Button
      v-if="!isSidebarView"
      variant="snack-ghost"
      size="icon"
      type="button"
      class="rounded-full shrink-0"
      @click="handlerBack"
    >
      <div class="i-material-symbols:chevron-left w-7 h-7" />
    </Button>
    <FieldTitle name="title" />
    <div class="ml-a items-center flex gap-1">
      <FormDebugger v-if="debugMode" />
      <FormErrorAlert />
      <FormSavingIndicator v-if="injected" />
      <TagMenu :elemental="elemental" />
      <OptionsButton
        :hidde-duplicate-action="elementalType?.id === ElementalTypeEnum.Cell"
        :hidde-copy-link-action="elementalType?.id === ElementalTypeEnum.Table || elementalType?.id === ElementalTypeEnum.Cell"
        :hidde-save-action="elementalType?.id === ElementalTypeEnum.Table || elementalType?.id === ElementalTypeEnum.Cell"
        :hidde-open-external-action="elementalType?.id === ElementalTypeEnum.Table || elementalType?.id === ElementalTypeEnum.Cell"
      />
    </div>
  </header>
  <teleport v-if="isSidebarView" to="#drawer-header-content" :defer="true">
    <ProductHeader class="w-full pl-2" hide-interaction-bar hide-elemental-menu is-in-library>
      <template #title>
        <div
          class="flex w-full items-center gap-2"
        >
          <FieldTitle name="title" />
          <div class="ml-a items-center justify-end flex gap-1">
            <FormDebugger v-if="debugMode" />
            <FormSavingIndicator v-if="injected" />
            <FormErrorAlert />
            <IconButton
              class="w-8 h-8 color-soft-black "
              icon-class="w-6 h-6" href="#advanced"
              @click="handlerScrollToAdvanced"
            >
              <IconAddWidget class="w-6 h-6" />
            </IconButton>
            <OptionsButton
              :hidde-duplicate-action="elementalType?.id === ElementalTypeEnum.Cell"
              :hidde-copy-link-action="elementalType?.id === ElementalTypeEnum.Table || elementalType?.id === ElementalTypeEnum.Cell"
              :hidde-save-action="elementalType?.id === ElementalTypeEnum.Table || elementalType?.id === ElementalTypeEnum.Cell"
              :hidde-open-external-action="elementalType?.id === ElementalTypeEnum.Table || elementalType?.id === ElementalTypeEnum.Cell"
            />
          </div>
        </div>
      </template>
    </ProductHeader>
  </teleport>
</template>
